/**
 * **계정 메뉴 한 벌** — 사이드바 발치 줄과 머리 오른쪽 아바타(계정 서랍)가 같은 항목·같은 목적지를 연다.
 *
 * ```
 *   설정 · 내 정보 · 결제 내역        앱 안 주소(설정 화면의 탭)
 *   Plan …                         요금 화면(업그레이드 안내) — 문구만 플랜마다 다르다
 *   데모 세션 · 실시간 문의           바깥 주소(새 탭)
 *   로그아웃                         그리는 자리가 단다(`SignOutButton`)
 * ```
 *
 * 🔑 두 메뉴가 따로 적으면 항목과 목적지가 갈린다 — 그리는 자리는 `AccountMenuItems` 하나다.
 * ⚠️ 데모 세션은 설정·내 정보·결제 내역이 막힌다 · 만료 워크스페이스는 설정이 막힌다.
 */

import { paths } from 'src/routes/paths';

/** 앱 안 항목 */
export type AccountMenuLink = {
  key: 'settings' | 'profile' | 'billing';
  label: string;
  href: string;
  /** 데모 세션에서 막힌다 */
  blockedInDemo: boolean;
  /** 만료 워크스페이스에서 막힌다 */
  blockedWhenExpired: boolean;
};

export const ACCOUNT_MENU_LINKS: AccountMenuLink[] = [
  { key: 'settings', label: '설정', href: paths.service.settings, blockedInDemo: true, blockedWhenExpired: true },
  { key: 'profile', label: '내 정보', href: paths.service.settingsTab('general'), blockedInDemo: true, blockedWhenExpired: false },
  { key: 'billing', label: '결제 내역', href: paths.service.settingsTab('subscribe'), blockedInDemo: true, blockedWhenExpired: false },
];

/** 바깥 도움 항목 — 새 탭으로 연다 · 위 항목들처럼 글자만 선다(아이콘 없음) */
export const ACCOUNT_HELP_LINKS: { label: string; href: string }[] = [
  { label: '데모 세션 요청하기', href: 'https://calendar.app.google/ESzTx9Qhh2XbhdMaA' },
  { label: '실시간 문의', href: 'https://catchmoments.channel.io' },
];

/** 플랜 단추가 가는 곳 — 업그레이드 안내로 연 요금 화면 하나 */
export const ACCOUNT_PLAN_HREF = `${paths.subscription.plan}?type=upgrade`;

/** 플랜 단추의 말 — 가장 위 플랜에 「올려라」는 말이 안 된다 */
export function accountPlanCtaLabel(planName: string | null | undefined): string {
  if (planName === 'Trial') return 'Plan 구독하기';
  if (planName === 'Brand') return 'Plan 알아보기';
  return 'Plan 업그레이드';
}

/** 사이드바 밖 화면의 머리 이름(「설정」)이 읽는 목록 */
export const account = ACCOUNT_MENU_LINKS.map(({ label, href }) => ({ label, href }));

/**
 * 사이드바 밖 화면의 머리 이름(`resolveNavHeading` 의 `extras`) — 계정 메뉴 이름 그대로(「설정」). 구역 없이 이름만 선다.
 * ⚠️ 같은 경로가 둘이면 앞의 것이 이긴다(「설정」 · 「내 정보」는 같은 `/service/settings` 아래).
 * 서비스 레이아웃과 mockup 껍데기가 같은 목록을 읽는다.
 */
export const ACCOUNT_HEADING_EXTRAS = account.map(({ label, href }) => ({ title: label, path: href }));
